import { configureStore } from "@reduxjs/toolkit";
import { contactApi } from "./api/ContactApi/contactApi";
import { servicesApi } from "./api/ServicesApi/servicesApi";

export const store = configureStore({
  reducer: {
    [contactApi.reducerPath]: contactApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      contactApi.middleware,
      servicesApi.middleware,
    ]),
});